import fetch from 'isomorphic-fetch'
import HooksModule from '../hooks/Module'
import DoPostError from './DoPostError'
import ClientModule from './Module'
import DevLog from '../devlog/Module'

export function getCSRFToken(): [string, string] {
  return [
    'undefined' !== typeof document
      ? document.querySelector('meta[name="csrf-param"]').getAttribute('content')
      : 'authenticity_token',
    'undefined' !== typeof document ? document.querySelector('meta[name="csrf-token"]').getAttribute('content') : ''
  ]
}

export async function doPost<PostResponse = unknown>(url: string, body: object) {
  const CSRFToken = getCSRFToken()

  if (HooksModule.hasPostHook) {
    try {
      const response = (await HooksModule.doPost(url, body, CSRFToken)) as PostResponse
      if (response) {
        return response
      }
    } catch {
      // skip misbehaving hook
    }
  }

  return await fetch(url, {
    method: 'POST',
    credentials: 'include',
    // mode: 'same-origin',
    headers: ClientModule.token
      ? {
          'X-CSRF-Token': CSRFToken[1],
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          authorization: ClientModule.token
        }
      : {
          'X-CSRF-Token': CSRFToken[1],
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
    body: JSON.stringify({ ...body, [CSRFToken[0]]: CSRFToken[1] })
  })
    .then(async response => {
      if (response.ok) {
        return response.json() as Promise<PostResponse>
      } else {
        if (HooksModule.hasErrorHook) {
          // await: doError is async — an un-awaited call is a truthy Promise, which
          // used to swallow every failure into a resolved null (the "null response" bug)
          const recover = await HooksModule.doError(new DoPostError(response, url, body))
          if (null != recover) {
            return recover as PostResponse
          }
        }
        throw new Error(`doPost failed: ${response.statusText}`)
      }
    })
    .catch(async error => {
      if (HooksModule.hasErrorHook) {
        const recover = await HooksModule.doError(error as string)
        if (null != recover) {
          return recover as PostResponse
        }
        DevLog.error(error, `SW[doPost]`)
      }
      throw new Error(`doPost failed: ${error?.message || error}`)
    })
}

export async function doInnerPost(url: string, body: object) {
  const CSRFToken = getCSRFToken()

  return await fetch(url, {
    method: 'POST',
    credentials: 'include',
    // mode: 'same-origin',
    headers: {
      'X-CSRF-Token': CSRFToken[1],
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ ...body, [CSRFToken[0]]: CSRFToken[1] })
  }).then(async response => {
    if (response.ok) {
      return response
    } else {
      if (HooksModule.hasErrorHook) {
        const recover = await HooksModule.doError(new DoPostError(response, url, body))
        if (null != recover) {
          return recover as Response
        }
      }
      throw new Error(`doInnerPost failed: ${response.statusText}`)
    }
  })
}
